import { AxiosResponse } from 'axios';

import apiClient from '../client';
import { AddOrderChargeDto, OrderChargesAndTotalsDto } from 'interfaces/orders/orderCharge';
import { ApiResponseDto } from 'interfaces/apiResponse';

interface OrderChargeService {
  get(orderId: string): Promise<OrderChargesAndTotalsDto>;
  add(orderId: string, postData: AddOrderChargeDto): Promise<OrderChargesAndTotalsDto>;
  update(orderId: string, chargeId: string, postData: AddOrderChargeDto): Promise<OrderChargesAndTotalsDto>;
  remove(orderId: string, chargeId: string): Promise<OrderChargesAndTotalsDto>;
}

const endpoints = {
  get: (orderId: string) => `/orders/${orderId}/charges`,
  add: (orderId: string) => `/orders/${orderId}/charges`,
  update: (orderId: string, chargeId: string) => `/orders/${orderId}/charges/${chargeId}`,
  remove: (orderId: string, chargeId: string) => `/orders/${orderId}/charges/${chargeId}`,
};

export const chargesService: OrderChargeService = {
  get: async (orderId: string): Promise<OrderChargesAndTotalsDto> => {
    const response: AxiosResponse<ApiResponseDto<OrderChargesAndTotalsDto>> = await apiClient.get(endpoints.get(orderId));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  add: async (orderId: string, postData: AddOrderChargeDto): Promise<OrderChargesAndTotalsDto> => {
    const response: AxiosResponse<ApiResponseDto<OrderChargesAndTotalsDto>> = await apiClient.post(endpoints.add(orderId), postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  update: async (orderId: string, chargeId: string, postData: AddOrderChargeDto): Promise<OrderChargesAndTotalsDto> => {
    const response: AxiosResponse<ApiResponseDto<OrderChargesAndTotalsDto>> = await apiClient.put(
      endpoints.update(orderId, chargeId),
      postData,
    );

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  remove: async (orderId: string, chargeId: string): Promise<OrderChargesAndTotalsDto> => {
    const response: AxiosResponse<ApiResponseDto<OrderChargesAndTotalsDto>> = await apiClient.delete(endpoints.remove(orderId, chargeId));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
